@if (type === 'top') {
  <div class="d-flex align-items-baseline">
    <label class="{{ maxChars ? '' : '' }} {{class}} fw-bold" appTranslate>{{ label }}</label>
    @if (maxChars) {
      <span class="ms-1 text-secondary fs-verysmall">{{ currentChars ? currentChars : 0 }}/{{ maxChars }} {{ 'CHARSLEFT' | translate }}</span>
    }
  </div>
}

@if (type === 'content') {
  <label [class]="class">{{ label }}</label>
}
